// extracted by mini-css-extract-plugin
module.exports = {"Tasks":"Tasks_Tasks__3BtNg","Tasks__item":"Tasks_Tasks__item__1E2J7"};